import { motion, LayoutGroup } from "framer-motion";
import { PROFILE_ORDER, PROFILES, useProfileStore } from "@/state/profile";
import { cn } from "@/lib/cn";

export function ProfileToggle() {
  const activeId = useProfileStore((s) => s.activeId);
  const setActive = useProfileStore((s) => s.setActive);

  return (
    <LayoutGroup id="profile-toggle">
      <div
        role="tablist"
        aria-label="Active profile"
        className="relative grid w-full max-w-sm grid-cols-2 gap-1 p-1 rounded-3xl bg-brand-surface border border-brand-border shadow-chunk"
      >
        {PROFILE_ORDER.map((id) => {
          const p = PROFILES[id];
          const active = activeId === id;
          return (
            <button
              key={id}
              role="tab"
              aria-selected={active}
              onClick={() => setActive(id)}
              className={cn(
                "relative z-10 min-h-10 px-3 py-2 rounded-2xl font-extrabold text-sm transition-colors",
                active ? "text-white" : "text-brand-muted",
              )}
            >
              {active && (
                <motion.span
                  layoutId="profile-toggle-pill"
                  className="absolute inset-0 rounded-2xl"
                  style={{ background: p.color }}
                  transition={{ type: "spring", stiffness: 400, damping: 32 }}
                />
              )}
              <span className="relative">{p.name}</span>
            </button>
          );
        })}
      </div>
    </LayoutGroup>
  );
}
